import { isDev } from '@/lib/util/isDev';
import Cookies from 'js-cookie';
import MissingKioskInstallationIdError from './error/MissingKioskInstallationIdError';

export const INSTALLATION_ID_KEY = 'KioskInstallationId';
export const USER_UUID_KEY = 'KioskUserUuid';
export const SOURCE_KEY = 'KioskSource';

export function getKioskInstallationId(): string {
  if (isDev()) {
    return '';
  }

  const urlParams = new URLSearchParams(window.location.search);

  const kioskInstallationId =
    Cookies.get(INSTALLATION_ID_KEY) || urlParams.get(INSTALLATION_ID_KEY);

  if (!kioskInstallationId) {
    throw new MissingKioskInstallationIdError();
  }

  return kioskInstallationId.replace(/\//g, '');
}

export function getKioskCreatorUuid(): string {
  const uuid = Cookies.get(USER_UUID_KEY);

  Cookies.remove(USER_UUID_KEY);

  return uuid || '';
}

export function resetCookieKioskInstallationId(): void {
  Cookies.set(INSTALLATION_ID_KEY, getKioskInstallationId(), {
    expires: 30,
  });
}

export function getKioskSource(): string {
  const source = Cookies.get(SOURCE_KEY);

  Cookies.remove(SOURCE_KEY);

  return source || '';
}
